import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-index-cell" }
const _hoisted_2 = { class: "table-index-cell__order" }
const _hoisted_3 = { class: "table-index-cell__id" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 justify-center" }, "ĐVT", -1)
const _hoisted_5 = { class: "d-flex align-items-center mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 break-word justify-center" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Số lượng")
], -1)
const _hoisted_7 = { class: "text-end mb-0 break-word" }
const _hoisted_8 = { class: "break-word" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_10 = { class: "text-end mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 break-word" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Thành tiền:")
], -1)
const _hoisted_12 = { class: "text-end mb-0 break-word" }
const _hoisted_13 = { class: "break-word" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VatTuDetailModal = _resolveComponent("VatTuDetailModal")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_WordBreakColumn = _resolveComponent("WordBreakColumn")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VatTuDetailModal, {
      "show-approve-button": false,
      "vat-tu-id": _ctx.selectedVatTuId,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedVatTuId = undefined)),
      onRefresh: _cache[1] || (_cache[1] = 
      () => {
        _ctx.selectedVatTuId = undefined;

        _ctx.$emit('refresh');
      }
    )
    }, null, 8, ["vat-tu-id"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      size: "medium",
      "empty-text": "Chưa có vật tư",
      "cell-style": { padding: '0', height: '10px' },
      border: true,
      data: _ctx.vatTuItems,
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: _ctx.columnWidths.stt
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
              _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_WordBreakColumn, {
          "min-width": "String(columnWidths.ten)",
          "header-title": "Tên",
          property: "ten_vat_tu"
        }),
        _createVNode(_component_WordBreakColumn, {
          width: String(_ctx.columnWidths.ma),
          "header-title": "Mã",
          property: "ma_vat_tu"
        }, null, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          width: _ctx.columnWidths.dvt
        }, {
          header: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : "-"), 1)
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          width: _ctx.columnWidths.soLuong
        }, {
          header: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_7, [
              _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.formatQuantity(scope.row.pivot.so_luong)), 1)
            ])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_WordBreakColumn, {
          width: String(_ctx.columnWidths.ghiChu),
          "header-title": "Ghi chú",
          property: "pivot.ghi_chu"
        }, null, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          label: "Thu hồi",
          width: _ctx.columnWidths.thuHoi
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.vatTuItems[scope.$index].thu_hoi,
              "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].thu_hoi) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_table_column, {
          label: "C/ty quản lý",
          width: _ctx.columnWidths.congTyQuanLy
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.vatTuItems[scope.$index].cong_ty_duyet,
              "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].cong_ty_duyet) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["width"]),
        (_ctx.showPriceAndTotal)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              width: _ctx.columnWidths.donGia
            }, {
              header: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatUnitPrice(scope.row.don_gia)), 1)
                ])
              ]),
              _: 1
            }, 8, ["width"]))
          : _createCommentVNode("", true),
        (_ctx.showPriceAndTotal)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              width: _ctx.columnWidths.thanhTien
            }, {
              header: _withCtx(() => [
                _hoisted_11
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_12, [
                  _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.thanhTienDisplay(scope.$index)), 1)
                ])
              ]),
              _: 1
            }, 8, ["width"]))
          : _createCommentVNode("", true),
        (_ctx.vatTuItems.length)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              width: _ctx.columnWidths.actions,
              fixed: "right",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_Setting, {
                  actions: _ctx.getSettingActions(scope.row)
                }, null, 8, ["actions"])
              ]),
              _: 1
            }, 8, ["width"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data", "row-class-name"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}